import { useEffect, useState } from 'react';

import {
  Box,
  Chip,
  TextField,
  Autocomplete,
  useTheme,
  Paper,
} from '@mui/material';

import toastError from '../../toasts/toastError';
import api from '../../services/api';

export function TagsFilter({ onFiltered }) {
  const theme = useTheme();

  const [tags, setTags] = useState([]);
  const [selecteds, setSelecteds] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await api.get(`/tags/list`);
        setTags(data);
      } catch (err) {
        toastError(err);
      }
    }
    fetchData();
  }, []);

  const onChange = (event, value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  return (
    <Box style={{ padding: '10px 10px 2.5px' }}>
      <Autocomplete
        multiple
        size='small'
        options={tags}
        value={selecteds}
        onChange={onChange}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant='outlined'
              sx={{
                backgroundColor: option.color || '#bfbfbf',
                textShadow: '1px 1px 1px #000',
                color: theme.custom.colors.text,
              }}
              label={option.name}
              {...getTagProps({ index })}
              size='small'
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant='outlined'
            placeholder='Filtro por Tags'
            sx={theme.custom.selectField}
          />
        )}
        PaperComponent={({ children }) => (
          <Paper
            sx={{
              backgroundColor: theme.custom.colors.defaultBackground,
              '& .MuiAutocomplete-listbox': {
                color: theme.custom.colors.text,
              },
              ...theme.custom.scrollbarStyles,
            }}
          >
            {children}
          </Paper>
        )}
      />
    </Box>
  );
}
